import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgTrophy = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.846 2.25a.75.75 0 0 0-.75.75v.635H3a.75.75 0 0 0-.75.75v1.384a4.904 4.904 0 0 0 4.904 4.904 4.9 4.9 0 0 0 4.096 4.096v5.481H8.539a.75.75 0 0 0 0 1.5h6.923a.75.75 0 0 0 0-1.5H12.75v-5.48a4.9 4.9 0 0 0 4.096-4.097A4.904 4.904 0 0 0 21.75 5.77V4.385a.75.75 0 0 0-.75-.75h-4.096V3a.75.75 0 0 0-.75-.75zm-.75 2.885v4.038A3.404 3.404 0 0 1 3.75 5.769v-.634zm1.5 4.801a3.404 3.404 0 0 0 6.808-.013V3.75H8.596v6.186m8.308-4.801v4.038a3.404 3.404 0 0 0 3.346-3.404v-.634z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgTrophy;
